import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { pageContext } from 'ctm-util-functions';
import { useSelector } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';

const breakpointMap = {
    xs: '100%',
    sm: '71rem',
    md: '93rem',
    lg: '114rem',
    xl: '114rem',
    xxl: '114rem'
};

// A utility component to bind a function to scroll event.
const ScrollWrapper = ({ children, handleScroll, resizeId }) => {
    const currentBreakpoint = pageContext.getProps().pageState.breakpoint;
    const viewType = useSelector((state) => resultsConfigSelector(state).get('displayMode'));

    const handleScrollEvent = () => {
        if (handleScroll) {
            handleScroll();
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScrollEvent);
        return () => {
            window.removeEventListener('scroll', handleScrollEvent);
        };
    }, [handleScroll]);

    useEffect(() => {
        // inside features view
        if (viewType === 'column' && resizeId) {
            const innerContainer = document.getElementById(resizeId)?.firstChild;
            if (innerContainer && innerContainer.style) innerContainer.style.width = breakpointMap[currentBreakpoint];
        }
    }, [viewType, currentBreakpoint]);

    return <div id={resizeId}>{children}</div>;
};

ScrollWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    handleScroll: PropTypes.func,
    resizeId: PropTypes.string
};

export { ScrollWrapper };
